import isEmpty from 'lodash/isEmpty';
import { useAppendDraftComment } from 'pages/WellGuardian/WIR/hooks';
import { getFinalWirReactiveScopeData } from 'pages/WellGuardian/WIR/utils';
import { WIRFinalWIRSections } from 'pages/WellGuardian/WIR/wir.constants';
import { useCallback, useMemo } from 'react';
import { useCountryState, useSelectedWIR } from 'redux/WellGuardian/selectors';
import wellGuardianApiClient from 'services/networking/wellGuardianApiClient';
import { WIR } from 'types/wellGuardian';

export const useSectionAssignInterventionSpdtData = () => {
  const wirFromState = useSelectedWIR();
  const { appendDraftComment } = useAppendDraftComment();
  const countryState = useCountryState();

  const assignInterventionSpdtPayload = useMemo(() => {
    const { phase, assignInterventionSPDT } = getFinalWirReactiveScopeData(
      wirFromState,
      countryState,
    );
    const userNameInterventionSpdt = assignInterventionSPDT?.userNameInterventionSpdt;
    const userIdInterventionSpdt = assignInterventionSPDT?.userIdInterventionSpdt;
    const comments = appendDraftComment(assignInterventionSPDT?.comments || []);
    const sectionCompleteConfirmation = assignInterventionSPDT?.sectionCompleteConfirmation;

    const isTicked = !isEmpty(userNameInterventionSpdt) && !isEmpty(userIdInterventionSpdt);

    return {
      userNameInterventionSpdt,
      userIdInterventionSpdt,
      isTicked,
      sectionCompleteConfirmation,
      comments,
      phase,
      lastUpdatedDate: new Date().toISOString(),
      assignedTo: assignInterventionSPDT?.assignedTo || '',
    };
  }, [wirFromState, appendDraftComment, countryState]);

  const saveAssignInterventionSpdtSection = useCallback(
    async (section: string, processSaveResponse: (wirResponse: WIR | null) => void) => {
      if (wirFromState?.wirNumber && section === WIRFinalWIRSections.assignInterventionSPDT) {
        processSaveResponse(
          await wellGuardianApiClient.updateWIRAssignInterventionSpdtSection(
            wirFromState?.wirNumber,
            assignInterventionSpdtPayload,
            countryState,
          ),
        );
      }
    },
    [wirFromState, assignInterventionSpdtPayload, countryState],
  );

  return {
    saveAssignInterventionSpdtSection,
    assignInterventionSpdtPayload,
  };
};
